import { useState } from 'react';

// สอง modal ที่เปิดจากดับเบิ้ลคลิกในแถวข้อมูล — "รายละเอียด" เปิด ExpensesDetail, "งาน-รหัสงบ" เปิด
// P111 project popup (ProjectPopup.js)
export function useApprovalModals() {
  const [detailModalId, setDetailModalId] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const openDetailModal = (id) => {
    setDetailModalId(id);
    setDetailModalOpen(true);
  };
  const closeDetailModal = () => setDetailModalOpen(false);

  const [popupProjectId, setPopupProjectId] = useState(null);

  return {
    detailModalId,
    detailModalOpen,
    openDetailModal,
    closeDetailModal,
    popupProjectId,
    setPopupProjectId,
  };
}
